import { createContext } from 'react';

export type RequestPushNotificationsContextProps = {
  isMessageOpen: boolean;
};

export const RequestPushNotificationsContext =
  createContext<RequestPushNotificationsContextProps>({ isMessageOpen: false });
